<template>
	<popup
			@updateClosePopup="onClose"
			@updateSave="onSave"
			height-head="40px"
			width="340px"
			:fullscreen="false"
			title="Add File"
	>
		<div class="filesWrapper">
			<field
					margin="0 0 10px"
					width="300px"
					label="File category"
					placeholder="Select file category"
					item-text="name"
					@updateAutocomplete="onAutocomplete($event)"
					:autocompleteValue="{id: 1, value: 'Other'}"
					:items="fileType"
					:isClearable="false"
					is-autocomplete
			></field>
			<field
					:class-error="$v.fileItem.value.$error"
					margin="0 10px 0 0"
					width="300px"
					label="File"
					placeholder="Add file"
					:setInputValue="fileItem.name"
					:is-file-icon="!!fileItem.name"
					@updateFile="setNewItem($event)"
					@updateView="onView"
					color-icon="#19BC38"
					is-file
					is-readonly
			></field>
		</div>
	</popup>
</template>

<script>
// shared
import Popup from "@/shared/Popup/Popup";
// validations
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

export default {
	name: "FilePopup",
	mixins: [ validationMixin ],
	components: { Popup },
	props: {
		fileType: Array
	},
	data: () => ({
		isPopup: true,
		downloadLink: '',
		fileItem: {
			create_at: "",
			employee: "",
			name: "",
			value: '',
			category_id: 1
		}
	}),
	validations: {
		fileItem: {
			value: { required }
		}
	},
	methods: {
		onClose() {
			this.$emit('updateClose');
		},
		onAutocomplete({ value }) {
			this.$set(this.fileItem, 'category_id', value.id);
		},
		setNewItem(e) {
			const iFile = e.target.files[0];
			const reader = new FileReader();

			reader.readAsDataURL(iFile);
			reader.onload = () => {
				this.fileItem.name = iFile.name;
				this.fileItem.value = reader.result;
				this.fileItem.create_at = new Date().toISOString().substr(0, 10);
			};
		},
		onView() {
			const { value } = this.fileItem;
			this.$emit('updateView', value);
		},
		onSave() {
			this.$v.$touch();
			if (!this.$v.$error) {
				this.$emit('updateFilesList', this.fileItem);
				this.onClose();
			}
		}
	}
};
</script>

<style scoped lang="scss">
@import "FilePopup";
</style>
